<template>
  <div class="fill-height d-flex" >

    <v-expand-x-transition>
      <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 35%">
        <template v-for="employee in filteredEmployees">
          <div class="pa-2">
            <v-card
              class="d-flex align-center"
              :key="employee._id"
              @click.self="$store.state.ref.employees.selected = $store.state.ref.employees.selected === employee ? null : employee"
              :raised="$store.state.ref.employees.selected === employee"
              hover
            >
              <div class="ml-2" @click.self="$store.state.ref.employees.selected = $store.state.ref.employees.selected === employee ? null : employee">
                <template v-if="$store.state.ref.employees.selected === employee">
                  <v-icon color="primary">mdi-check-circle</v-icon>
                </template>
                <template v-else>
                  <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                </template>
              </div>

              <div class="subtitle-1 font-weight-light flex-grow-1 flex-equal pa-2 text-truncate" @click.self="$store.state.ref.employees.selected = $store.state.ref.employees.selected === employee ? null : employee">
                {{employee.name}}
              </div>

              <div class="d-flex align-center pr-2">
                <div @click.stop="access.setup ? gotoTeamSettings(employee.teamId) : () => {}">
                  <app-outlined-chip
                    v-if="employee.teamId && teamsRef[employee.teamId]"
                    :label="teamsRef[employee.teamId].name"
                    icon="mdi-account-multiple"
                    color="primary"
                  />
                </div>
              </div>

              <div class="d-flex align-center">
                <v-tooltip top>
                  <template v-slot:activator="{on}">
                    <v-icon :color="devicesByEmployee[employee._id] ? 'primary' : 'error'" v-on="on" class="pr-2">
                      {{ devicesByEmployee[employee._id] ? 'mdi-cellphone-link' : 'mdi-alert-outline' }}
                    </v-icon>
                  </template>
                  {{devicesByEmployee[employee._id] ? `${devicesByEmployee[employee._id].length} Device${devicesByEmployee[employee._id].length > 1 ? 's' : ''}` : 'No devices assigned to employee'}}
                </v-tooltip>
              </div>

              <!--                            <v-speed-dial-->
              <!--                                    class="pa-0 ma-0 mr-3"-->
              <!--                                    direction="left"-->
              <!--                                    open-on-hover-->
              <!--                            >-->
              <!--                                <template v-slot:activator>-->
              <!--                                    <v-btn-->
              <!--                                            color="primary"-->
              <!--                                            dark-->
              <!--                                            small-->
              <!--                                            icon-->
              <!--                                    >-->
              <!--                                        <v-icon>-->
              <!--                                            mdi-cog-->
              <!--                                        </v-icon>-->
              <!--                                    </v-btn>-->
              <!--                                </template>-->

              <!--                                <v-tooltip top>-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-btn-->
              <!--                                                class="indigo"-->
              <!--                                                color="white"-->
              <!--                                                icon-->
              <!--                                                v-on="on"-->
              <!--                                                @click="(event) => {-->
              <!--                                                    event.preventDefault()-->
              <!--                                                    $store.state.ref.employees.selected = employee-->
              <!--                                                    $nextTick(() => {-->
              <!--                                                        $refs.sidebar.showAddDevices = true;-->
              <!--                                                    })-->
              <!--                                                }"-->
              <!--                                        >-->
              <!--                                            <v-icon>mdi-plus</v-icon>-->
              <!--                                        </v-btn>-->
              <!--                                    </template>-->
              <!--                                    Add Employees-->
              <!--                                </v-tooltip>-->

              <!--                                <v-tooltip top>-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-btn-->
              <!--                                                class="blue"-->
              <!--                                                color="white"-->
              <!--                                                icon-->
              <!--                                                v-on="on"-->
              <!--                                                @click="-->
              <!--                                                (event) => {-->
              <!--                                                    event.preventDefault()-->
              <!--                                                    $store.state.ref.employees.selected = employee-->
              <!--                                                    $nextTick(() => {-->
              <!--                                                        $refs.sidebar.showAssignTeam = true;-->
              <!--                                                    })-->
              <!--                                                }"-->
              <!--                                        >-->
              <!--                                            <v-icon>mdi-account-group</v-icon>-->
              <!--                                        </v-btn>-->
              <!--                                    </template>-->
              <!--                                    Assign Team-->
              <!--                                </v-tooltip>-->

              <!--                                <v-tooltip top>-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-btn-->
              <!--                                                class="green"-->
              <!--                                                color="white"-->
              <!--                                                icon-->
              <!--                                                v-on="on"-->
              <!--                                                @click="-->
              <!--                                                (event) => {-->
              <!--                                                    event.preventDefault()-->
              <!--                                                    $store.state.ref.employees.selected = employee-->
              <!--                                                    $nextTick(() => {-->
              <!--                                                        $refs.sidebar.showRenameEmployee = true;-->
              <!--                                                    })-->
              <!--                                                }"-->
              <!--                                        >-->
              <!--                                            <v-icon>mdi-pencil</v-icon>-->
              <!--                                        </v-btn>-->
              <!--                                    </template>-->
              <!--                                    Rename Employee-->
              <!--                                </v-tooltip>-->

              <!--                                <v-tooltip top>-->
              <!--                                    <template v-slot:activator="{on}">-->
              <!--                                        <v-btn-->
              <!--                                                class="red"-->
              <!--                                                color="white"-->
              <!--                                                icon-->
              <!--                                                v-on="on"-->
              <!--                                                @click="(event) => {-->
              <!--                                                    event.preventDefault()-->
              <!--                                                    $store.state.ref.employees.selected = employee-->
              <!--                                                    $nextTick(() => {-->
              <!--                                                        $refs.sidebar.showDisableEmployee = true-->
              <!--                                                    })-->
              <!--                                                }"-->
              <!--                                        >-->
              <!--                                            <v-icon>{{employee.disabled ? 'mdi-lock-off' : 'mdi-lock'}}</v-icon>-->
              <!--                                        </v-btn>-->
              <!--                                    </template>-->
              <!--                                    {{ employee.disabled ? 'Enable Employee' : 'Disable Employee' }}-->
              <!--                                </v-tooltip>-->
              <!--                            </v-speed-dial>-->

            </v-card>
          </div>
        </template>
      </div>
    </v-expand-x-transition>


    <v-slide-x-reverse-transition>
      <div v-if="selectedEmployee" class="fill-height" style="width: 65%">
        <app-employee-side-bar
          :selected-employee="selectedEmployee"
          ref="sidebar"
          @checkSelected="checkSelectedEmployeeTab"
        />
      </div>
    </v-slide-x-reverse-transition>



    <!--        <app-employees-active v-if="$store.state.ref.employees.tabIndex === 0"/>-->
    <app-employee-add
      v-if="$store.state.ref.employees.showAdd"
      :shown.sync="$store.state.ref.employees.showAdd"
      @input="(event) => {
                    $store.state.ref.employees.tabIndex = 0;
                    con.log(event)
                    $store.state.ref.employees.selected = event
                }"
    />

  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {nameSort} from "@/core/codeFunctions";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import AppEmployeeAdd from "@/components/Employees/AppEmployeeAdd";
import AppEmployeeSideBar from "@/components/Employees/AppEmployeeSideBar";
export default {
  components: {AppEmployeeSideBar, AppEmployeeAdd, AppOutlinedChip},
  props: {
    shown: Boolean
  },
  data() {
    return {
      con: console
    }
  },
  watch: {
    "$store.state.ref.users.selected"() {
      this.userChanged = true;
      this.$nextTick(() => {
        this.userChanged = false;
      })
    },
    "$store.state.ref.employees.tabIndex"() {
      this.checkSelectedEmployeeTab()
    }
  },
  created() {
    this.employees.on('deleted', this.deselectDeleted)
  },
  beforeUnmount() {
    this.employees.off('deleted', this.deselectDeleted)
  },
  mounted() {
    this.checkSelectedEmployeeTab();
  },
  methods: {
    ...mapActions(['gotoTeamSettings']),
    checkSelectedEmployeeTab() {
      if (
        this.selectedEmployee && (
          this.$store.state.ref.employees.tabIndex === 0 && this.selectedEmployee.disabled
          || (this.$store.state.ref.employees.tabIndex === 1 && !this.selectedEmployee.disabled)
        )
      ) {
        this.$store.state.ref.employees.selected = null;
      }
    },
    deselectDeleted(delObj) {
      if (this.$store.state.ref.employees.selected === delObj)
        this.$store.state.ref.employees.selected = null
    }
  },
  computed: {
    ...mapGetters(['employees', 'teamsRef', 'devicesByEmployee', 'employeesWithAccess', 'access']),
    selectedEmployee() {
      return this.$store.state.ref.employees.selected || null
    },
    filteredEmployees() {
      return this.employeesWithAccess.filter((employee) => {
        if (this.$store.state.ref.employees.tabIndex === 0 && employee.disabled)
          return false
        if (this.$store.state.ref.employees.tabIndex === 1 && !employee.disabled)
          return false
        if (this.$store.state.ref.employees.filterStr && !JSON.parse(JSON.stringify(employee).toLowerCase().includes((this.$store.state.ref.employees.filterStr || '').toLowerCase())))
          return false
        return true
      })
        .sort(nameSort)
    },
  },
}
</script>

<style scoped>

</style>